<template>
    <div style="width: 99%; display: block; padding: 5px; margin-left: auto; margin-right: auto;">
        <b-modal id="modal-co-items" @hide="fetch_orders" scrollable title="CONTAINER ORDER ITEMS" size="xl" hide-footer style="min-height: 700px;">
            <ContainerOrderItems v-on:done-items-co="close_co_items" style="min-height: 700px;" :viewdata="{container_order_id: container_order_id, container_order_vendor_id: container_order_vendor_id}" />
        </b-modal>

        <b-modal id="email-container-po-modal" title="Send Container PO via Email" @hidden="resetEmailForm" hide-footer>
            <b-form @submit.prevent="sendContainerPOEmail">
                <div class="row mb-3">
                    <div class="col-md-12">
                        <b-form-group label="Email Address" label-for="email-address" :state="!!emailForm.email">
                            <b-form-input
                                id="email-address"
                                v-model="emailForm.email"
                                type="email"
                                placeholder="Enter vendor email address"
                                required
                                :state="!!emailForm.email"
                            ></b-form-input>
                            <b-form-invalid-feedback>Email address is required</b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-12">
                        <b-form-group label="Subject" label-for="email-subject">
                            <b-form-input
                                id="email-subject"
                                v-model="emailForm.subject"
                                placeholder="Email subject"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-12">
                        <b-form-group label="Message" label-for="email-message">
                            <b-form-textarea
                                id="email-message"
                                v-model="emailForm.message"
                                placeholder="Optional message to include with the email"
                                rows="4"
                            ></b-form-textarea>
                        </b-form-group>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-12">
                        <h6>Order Details</h6>
                        <div class="alert alert-info">
                            <strong>PO #:</strong> {{ emailForm.poNumber }}<br>
                            <strong>Container #:</strong> {{ emailForm.containerNumber }}<br>
                            <strong>Vendor:</strong> {{ emailForm.vendorName }}<br>
                            <strong>Items:</strong> {{ emailForm.itemsCount }} items
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-end mt-4">
                    <b-button variant="secondary" @click="$bvModal.hide('email-container-po-modal')" class="mr-2">
                        Cancel
                    </b-button>
                    <b-button variant="primary" type="submit" :disabled="!emailForm.email">
                        Send Email
                    </b-button>
                </div>
            </b-form>
        </b-modal>

        <!-- Product Detail Modal - FIXED: Properly handle visibility and data -->
        <ProductDetailModal 
            ref="productDetailModal"
            :productSku="currentDetailProductSku"
            :orderData="currentDetailOrderData"
            v-if="showProductDetail"
            @view-product="viewProductDetail"
            @open-product-detail="openProductDetail"
            @hidden="handleProductModalHidden"
        />

        <div style="display: block; margin-top: 10px;">
            <div
              v-if="isMobile"
              class="d-flex justify-content-between align-items-center mb-2 px-1"
            >
              <b-button
                size="sm"
                variant="outline-primary"
                @click="filtersVisible = !filtersVisible"
              >
                <b-icon-funnel-fill class="mr-1"></b-icon-funnel-fill>
                {{ filtersVisible ? 'Hide Filters' : 'Show Filters' }}
              </b-button>
            </div>

            <b-collapse :visible="!isMobile || filtersVisible" class="mb-2">
              <b-alert variant="secondary" show>
                <div style="width: 250px; margin: 5px; display: inline-block; vertical-align: top;">
                  <div>SCHEDULE ETA</div>
                  <date-picker
                    v-model="date_range"
                    format="MM-DD-YYYY"
                    valueType="format"
                    style="width: 220px; font-size: 15px; display: block;"
                    placeholder="DATE OR DATE RANGE"
                    range
                  ></date-picker>
                </div>

                <div style="width: 250px; margin: 5px; display: inline-block; vertical-align: top;">
                  <div>STATUS</div>
                  <b-form-select :options="statuses" v-model="status">
                    <template #first>
                      <b-form-select-option :value="null">OPEN</b-form-select-option>
                    </template>
                  </b-form-select>
                </div>

                <div style="width: 200px; margin: 5px; display: inline-block; vertical-align: top;">
                <div>CONTAINER STATUS</div>
                <b-form-select :options="containerStatusFilterOptions" v-model="containerStatusFilter"></b-form-select>
                </div>

                <div style="width: 150px; margin: 5px; display: inline-block; vertical-align: top;">
                  <div>VENDOR</div>
                  <b-form-select :options="packet.vendors" v-model="vendor"></b-form-select>
                </div>

                <div style="width: 150px; margin: 5px; display: inline-block; vertical-align: top;">
                  <div>CATEGORY</div>
                  <b-form-select :options="categoryOptions" v-model="category"></b-form-select>
                </div>

                <div style="width: 300px; margin: 5px; display: inline-block; vertical-align: top;">
                  <div>SEARCH PO#</div>
                  <div style="display: inline-block; vertical-align: top; width: 200px;">
                    <b-form-input v-model="search_keyword"></b-form-input>
                  </div>
                  <div style="display: inline-block; vertical-align: top;">
                    <b-button variant="primary">SEARCH</b-button>
                  </div>
                </div>
              </b-alert>
            </b-collapse>

            <b-alert show>
                <div style="display: flex; justify-content: space-between;">
                    <div cols="1">
                        <b-button v-if="this.packet.userDetails.userrole == 'admin'" size="sm" variant="success" @click="add_new_container_order">ADD NEW</b-button>
                        <b-button size="sm" variant="primary" @click="fetch_orders">RELOAD</b-button>
                    </div>
                    <div cols="9">&nbsp;</div>
                    <div>
                        <button @click="prevPage">PREVIOUS</button>
                        <button @click="nextPage">NEXT</button>
                    </div>
                </div>
            </b-alert>

            <div v-if="create_new==true">
                <b-card-text style="display: inline-block; margin: 5px; text-align: center; vertical-align: top;">
                    <b-button size="sm" variant="danger" @click="create_new=!create_new;">CANCEL</b-button>
                </b-card-text>
            </div>

            <div>
                <div v-if="items_being_loaded == true">
                    <loading
                    :active="true"
                    :can-cancel="false"
                    :is-full-page="true">
                    </loading>
                </div>

                <div v-else>
                    <div v-if="items.length == 0">
                        <b-alert show variant="warning"> NO CONTAINER ORDERS</b-alert>
                    </div>
                    <div v-else>
                        <div class="diver">
                            <table>
                                <thead>
                                <tr>
                                    <th style="width: 150px; border:none; background-color: lightblue;" class="srr" @click="sort_by('vendor_id')"></th>
                                    <th style="width: 150px; border: none; background-color: lightblue;" class=""></th>
                                    <th style="width: 150px; border: none; background-color: lightblue;" class="srr"></th>
                                    <th style="width: 180px; border: none; background-color: lightblue;" class="srr"></th>
                                    <th style="width: 100px; border: none; background-color: lightblue;" class="srr"></th>
                                    <th style="width: 100px; border: none; background-color: lightblue;" class="srr"></th>
                                    
                                    <th style="width: 140px; border: none; background-color: lightblue; font-size: 20px;" class="srr">ORDER</th>
                                    <th style="width: 150px; border: none; background-color: lightblue; font-size: 20px;" class="srr">DETAILS</th>
                                    
                                    <th style="width: 140px; border: none; background-color: lightblue;" class="srr"></th>
                                    <th style="width: 150px; border: none; background-color: lightblue;" class="srr"></th>
                                    <th class="srr" style="width: 150px; border: none; background-color: lightblue;"></th>
                                    <th class="srr" style="width: 150px; border: none; background-color: lightblue;"></th>
                                    <th class="srr" style="width: 150px; border: none; background-color: lightblue;"></th>
                                    
                                
                                    <th class="srr" style="width: 130px; border: none; background-color: lightyellow;"></th>
                                    <th class="srr" style="width: 180px; border: none; background-color: lightyellow;"></th>
                                    <th class="srr" style="width: 150px; border: none; background-color: lightyellow;"></th>
                                    <th class="srr" style="width: 140px; border: none; background-color: lightyellow; font-size: 20px;">ITEM</th>
                                    <th class="srr" style="width: 140px; border: none;background-color: lightyellow; font-size: 20px;">DETAILS</th>
                                    <th class="srr" style="width: 100px; border: none; background-color: lightyellow;"></th>
                                    <th class="srr" style="width: 70px; border: none; background-color: lightyellow;"></th>
                                    <th class="srr" style="width: 70px; border: none; background-color: lightyellow;"></th>
                                    <th class="srr" style="width: 100px; border: none; background-color: lightyellow;"></th>
                                    
                                
                                    <th class="srr"
                                        v-if="['admin'].includes(userDetails.userrole)"
                                        style="width: 120px; border: none; background-color: lightgreen;"></th>
                                        <th class="srr"
                                        v-if="['admin'].includes(userDetails.userrole)"
                                        style="width: 120px; border: none; background-color: lightgreen; font-size: 20px;">PAYMENT</th>
                                    <th class="srr"
                                        v-if="['admin'].includes(userDetails.userrole)"
                                        style="width: 120px; border: none; background-color: lightgreen; font-size: 20px;">DETAILS</th>
                                    <th class="srr"
                                        v-if="['admin'].includes(userDetails.userrole)"
                                        style="width: 120px; border: none; background-color: lightgreen;"></th>
                                    <th class="srr"
                                        v-if="['admin'].includes(userDetails.userrole)"
                                        style="width: 120px; border: none; background-color: lightgreen;"></th>
                                    <th class="srr"
                                        v-if="['admin'].includes(userDetails.userrole)"
                                        style="width: 120px; border: none; background-color: lightgreen;"></th>
                                    
                                    <th class="srr"
                                        :disabled="userDetails.userrole === 'warehouseuser'"
                                        style="width: 60px; background-color: white;">
                                    </th>
                                    
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 140px; border: none; background-color: #9ec5ef;"></th>
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 140px; border: none; background-color: #9ec5ef;"></th>
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 100px; border: none; background-color: #9ec5ef;"></th>
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 140px; border: none; background-color: #9ec5ef;"></th>
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 100px; border: none; background-color: #9ec5ef; font-size: 20px;">VENDOR</th>
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 100px; border: none; background-color: #9ec5ef; font-size: 20px;">INVOICE</th>
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 140px; border: none; background-color: #9ec5ef; font-size: 20px;">DETAILS</th>
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 100px; border: none; background-color: #9ec5ef;"></th>
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 140px; border: none; background-color: #9ec5ef;"></th>
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 100px; border: none; background-color: #9ec5ef;"></th>
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 100px; border: none; background-color: #9ec5ef;"></th>
                                    
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 150px; border: none; background-color: #d1d1d1;"></th>
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 150px; border: none; background-color: #d1d1d1;"></th>
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 140px; border: none; background-color:  #d1d1d1;"></th>
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 150px; border: none; background-color:  #d1d1d1; font-size: 20px;">OCEAN</th>
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 100px; border: none; background-color:  #d1d1d1; font-size: 20px;">FREIGHT</th>
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 100px; border: none; background-color:  #d1d1d1;"></th>
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 140px; border: none; background-color:  #d1d1d1;"></th>
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 100px; border: none; background-color:  #d1d1d1;"></th>
                                    
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 100px; border: none; background-color: #94ffad; font-size: 20px;">TARIF</th>
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 140px; border: none; background-color: #94ffad; font-size: 20px;"> DETAILS</th>
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 100px; border: none; background-color: lightcyan;  font-size: 20px;">BROKER</th>
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 100px; border: none; background-color: lightcyan;  font-size: 20px;">ISF</th>
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 140px; border: none; background-color:  #ffb6b6; "></th>
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 140px; border: none; background-color:  #ffb6b6; font-size: 20px;">FINES</th>
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 100px; border: none; background-color:  #ffb6b6; font-size: 20px;">PENALTIES</th>
                                 
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 100px; border: none; background-color:  #ffb6b6;"></th>

                                    
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 140px; border: none; background-color: #dfcdff; "></th>
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 100px; border: none; background-color: #dfcdff; "></th>
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 100px; border: none; background-color: #dfcdff; font-size: 20px;">INLAND</th>
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 100px; border: none; background-color: #dfcdff; font-size: 20px;">FREIGHT</th>
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 140px; border: none; background-color: #dfcdff;"></th>
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 100px; border: none; background-color: #dfcdff;"></th>
                                    
                                    <th v-if="isDetailsExpanded" class="srr" style="width: 140px; background-color: #ffb6b6; font-size: 20px;">COMMENTS</th>
                                    
                                    <th style="width: 250px; background-color: white;" class="srr"></th>
                                </tr>
                            </thead>
                                <thead>
                                    <tr>
                                        <th style="width: 150px; background-color: lightblue;" class="srr" @click="sort_by('vendor_id')">VENDOR</th>
                                        <th style="width: 150px; background-color: lightblue;" class="srr">PO #</th>
                                        <th style="width: 150px; background-color: lightblue;" class="srr">INVOICE #</th>
                                        <th style="width: 180px; background-color: lightblue;" class="srr">CONTAINER #</th>
                                        <th style="width: 100px; background-color: lightblue;" class="srr">CREATED BY</th>
                                        <th style="width: 100px; background-color: lightblue;" class="srr">CREATED AT</th>
                                        <th style="width: 140px; background-color: lightblue;" class="srr">ORDERED DATE</th>
                                        <th style="width: 140px; background-color: lightblue;" class="srr">SCHEDULE DATE</th>
                                        <th style="width: 150px; background-color: lightblue;" class="srr">STATUS</th>
                                        <th style="width: 150px;background-color: lightblue;" class="srr">CONTAINER STATUS</th>
                                        <th class="srr" style="width: 150px; background-color: lightblue;">BILL TO</th>
                                        <th class="srr" style="width: 150px; background-color: lightblue;">SHIP TO</th>
                                        <th class="srr" style="width: 150px; background-color: lightblue;">RCV LOCATION</th>
                                        <th class="srr" style="width: 140px; background-color: lightyellow;">RQST SCHEDULE</th>
                                        <th class="srr" style="width: 140px;  background-color: lightyellow;">ARRIVAL ETA</th>
                                        <th class="srr" style="width: 130px;  background-color: lightyellow;">ETA TIME</th>
                                        <th class="srr" style="width: 180px; background-color: lightyellow;">ITEMS</th>
                                        <th class="srr" style="width: 150px;  background-color: lightyellow;">CATEGORIES</th>
                                        <th class="srr" style="width: 100px;  background-color: lightyellow;">CUBES</th>
                                        <th class="srr" style="width: 70px;  background-color: lightyellow;">ITEMS RCVD</th>
                                        <th class="srr" style="width: 70px;  background-color: lightyellow;">ITEMS REMNG</th>
                                        <th class="srr" style="width: 100px;  background-color: lightyellow;">RCVNG DATES</th>
                                        <th class="srr"
                                        v-if="['admin'].includes(userDetails.userrole)"
                                        style="width: 120px;background-color: lightgreen;">INVOICE TOTAL</th>
                                        <th class="srr"
                                        v-if="['admin'].includes(userDetails.userrole)"
                                        style="width: 120px;background-color: lightgreen;">TARIFF</th>
                                      
                                        <th class="srr"
                                        v-if="['admin'].includes(userDetails.userrole)"
                                        style="width: 120px;background-color: lightgreen;">OCEAN FREIGHT</th>
                                          <th class="srr"
                                        v-if="['admin'].includes(userDetails.userrole)"
                                        style="width: 120px;background-color: lightgreen;">INLAND FREIGHT</th>
                                          <th class="srr"
                                        v-if="['admin'].includes(userDetails.userrole)"
                                        style="width: 120px;background-color: lightgreen;">OTHER COST</th>
                                        <th class="srr"
                                        v-if="['admin'].includes(userDetails.userrole)"
                                        style="width: 120px;background-color: lightgreen;">LANDED</th>
                                        <th class="srr"
                                        :disabled="userDetails.userrole === 'warehouseuser'"
                                        style="width: 60px;">
                                            <b-button size="sm" @click="isDetailsExpanded = !isDetailsExpanded" variant="outline-primary">
                                                {{ isDetailsExpanded ? 'hide' : 'show' }}
                                            </b-button>
                                        </th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 140px;">ETD</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 140px;">INVOICE DATE</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 100px;">INVOICE #</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 140px;">PYMT DUE DATE</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 100px;">TOTAL AMT</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 100px;">PYMT 1ST AMT</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 140px;">PYMT 1ST DATE</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 100px;">PYMT 2ND AMT</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 140px;">PYMT 2ND DATE</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 100px;">BALANCE</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 100px;">PYMT METHOD</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 150px;">CONTAINER #</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 150px;">BL #</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 140px;">FREIGHT INVC DATE</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 150px;">FREIGHT INVC #</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 100px;">FREIGHT COMPANY</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 100px;">FREIGHT AMT</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 140px;">PAID DATE</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 100px;">PYMT METHOD</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 100px;">TARIFF TOTAL</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 140px;">TARIFF PAID DATE</th>

                                        <th v-if="isDetailsExpanded" class="srr" style="width: 100px;">BROKER FEES</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 100px;">ISF FILLING</th>
                                        


                                        <th v-if="isDetailsExpanded" class="srr" style="width: 100px;">DMRG CHARGES</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 140px;">DMRG PAID DATE</th>
                                        
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 100px;">HANDLING CHARGES</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 100px;">DETENTION CHARGES</th>
                                     
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 140px;">TRUCK INV DATE</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 100px;">TRUCK COMPANY</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 100px;">TRUCK INV #</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 100px;">TRUCK INV AMT</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 140px;">TRUCK PAID DATE</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 100px;">PYMT METHOD</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 140px;">COMMENTS</th>
                                        <th style="width: 250px;" class="srr">ACTION</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item,idx in filter" v-bind:key="idx">
                                        <td>
                                            <b-form-select
                                                :disabled="isItemDisabled2(item)"
                                                size="sm"
                                                :options="packet.vendors"
                                                name="vendor_id"
                                                v-model="item.data.vendor_id"
                                                @input="onVendorSelected(item)">
                                            </b-form-select>
                                        </td>
                                        <td class="srrv">
                                            <b-input size="sm" name="po_number"
                                                v-model="item.data.po_number"
                                                style="background:#EBEBEB; margin: 3px;"
                                                placeholder="PO #"
                                                readonly
                                                :state="validateOrderNumber(item)">
                                            </b-input>
                                        </td>
                                        <td class="srrv">
                                            <b-input size="sm"
                                                v-model="item.data.invoice_number"
                                                style=" margin: 3px;"
                                                :disabled="isItemDisabled(item) || isItemDisabled2(item)"
                                                placeholder="INVOICE #">
                                            </b-input>
                                        </td>
                                        <td class="srrv">
                                            <b-input size="sm"
                                                v-model="item.data.container_num"
                                                style=" margin: 3px;"
                                                placeholder="CONTAINER #">
                                            </b-input>
                                        </td>
                                        <td class="srrv">
                                            {{item.created_by }}
                                        </td>
                                        <td class="srrv">
                                            {{ formatDateWithoutTime(item.created_at) }}
                                        </td>
                                        <td class="srrv" :class="{ 'ordered-date-cell': item.data.ordered_date_display }">
                                            <date-picker
                                                v-model="item.data.ordered_date_display"
                                                format="MM-DD-YYYY"
                                                valueType="format"
                                                :disabled="isItemDisabled(item) || isItemDisabled2(item) || item.data.status === 5"
                                                style="padding: 4px; font-size: 11px; text-align: center; border: 1px solid gray; width: 130px;"
                                                placeholder="MM-DD-YYYY"
                                                @change="handleOrderedDateChange(item)">
                                            </date-picker>
                                        </td>
                                        <td class="srrv" :class="{ 'schedule-date-cell': item.data.schedule_date_display }">
                                            <date-picker
                                                v-model="item.data.schedule_date_display"
                                                format="MM-DD-YYYY"
                                                valueType="format"
                                                :disabled="isItemDisabled(item) || isItemDisabled2(item)"
                                                style="padding: 4px; font-size: 11px; text-align: center; border: 1px solid gray; width: 130px;"
                                                placeholder="MM-DD-YYYY"
                                                @change="handleScheduleDateChange(item)">
                                            </date-picker>
                                        </td>
                                        <td class="srrv">
                                            <b-form-select
                                                :disabled="isItemDisabled2(item)"
                                                size="sm"
                                                :options="getStatusOptions(item)"
                                                v-model="item.data.status"
                                                @change="handleStatusChange(item)">
                                            </b-form-select>
                                        </td>
                                        <td class="srrv">
                                            <b-form-select
                                                :disabled="isItemDisabled(item) || isItemDisabled2(item)"
                                                size="sm" 
                                                name="container_statuses"
                                                :options="container_statuses" 
                                                v-model="item.data.container_status"
                                                @change="handleContainerStatusChange(item)">
                                            </b-form-select>
                                        </td>
                                        <td class="srrv">
                                            <b-form-select
                                                :disabled="isItemDisabled(item) || isItemDisabled2(item)"
                                                size="sm"
                                                :options="bill_to_locations"
                                                v-model="item.data.bill_to"
                                                @change="handleBillToChange(item)">
                                            </b-form-select>
                                        </td>
                                        <td class="srrv">
                                            <b-form-select
                                                :disabled="isItemDisabled(item) || isItemDisabled2(item)"
                                                size="sm"
                                                :options="ship_to_locations"
                                                v-model="item.data.ship_to"
                                                @change="handleShipToChange(item)">
                                            </b-form-select>
                                        </td>
                                        <td class="srrv" style="background: lightblue;">
                                            <b-form-select
                                                :disabled="isItemDisabled(item) || isItemDisabled2(item)"
                                                size="sm"
                                                :options="getFilteredReceivingLocations(item)"
                                                v-model="item.data.receiving_location">
                                            </b-form-select>
                                        </td>
                                        <td class="srrv" style="background: lightyellow;">
                                            <date-picker
                                                v-model="item.data.final_eta"
                                                format="MM-DD-YYYY"
                                                valueType="format"
                                                name="final_eta"
                                                :disabled="isItemDisabled(item) || isItemDisabled2(item)"
                                                style="padding: 4px; font-size: 11px; text-align: center; border: 1px solid gray; width: 120px;"
                                                @change="handleEtaDateChange(item)">
                                            </date-picker>
                                        </td>
                                        <td class="srrv">
                                            <date-picker
                                                v-model="item.data.requested_eta"
                                                format="MM-DD-YYYY"
                                                valueType="format"
                                                :disabled="isItemDisabled(item) || isItemDisabled2(item)"
                                                style="padding: 4px; font-size: 11px; text-align: center; border: 1px solid gray; width: 120px;">
                                            </date-picker>
                                        </td>
                                     
                                        <td class="srrv" style="background: lightyellow;">
                                            <b-form-input
                                                size="sm"
                                                v-model="item.data.final_eta_time"
                                                type="time"
                                                class="custom-time-input"
                                                :disabled="isItemDisabled(item) || isItemDisabled2(item)"
                                                style="color: grey; font-size: 14px; text-align: center; border: 1px solid #ccc; width: 120px;"
                                                placeholder="HH:MM">
                                            </b-form-input>
                                        </td>
                                        <td class="srrv">
                                            <div v-if="item.detailed && (item.product_skus||[]).length > 0">
                                                <button @click="item.detailed = false">HIDE</button>
                                                <div v-for="p,pidx in item.product_skus" v-bind:key="pidx" style="display: block; margin: 5px;">
                                                    <div class="box" variant="success" style="font-size: 11px;">{{p.product_sku}}</div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <button @click="item.detailed = true">SHOW {{(item.product_skus || []).length}} ITEMS</button>
                                            </div>
                                        </td>
                                        <td class="srrv">
                                            <div v-if="item.detailed && (item.categories||[]).length > 0">
                                                <button @click="item.detailed = false">HIDE</button>
                                                <div v-for="ct,ctidx in item.categories" v-bind:key="ctidx" style="display: block; margin: 5px;">
                                                    <div class="box" variant="primary" style="font-size: 11px;">{{packet.categoriesdict[ct]}}</div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <button @click="item.detailed = true">SHOW {{(item.categories || []).length}} CATGRS</button>
                                            </div>
                                        </td>
                                        <td class="srrv">{{item.cubes && Number(item.cubes).toFixed(2)}}</td>
                                        <td class="srrv" style="background:lightyellow;">
                                            {{item.received_items}}
                                        </td>
                                        <td class="srrv" style="background:lightyellow;">
                                            {{item.remaining_items}}
                                        </td>
                                        <td class="srrv" style="background: lightyellow;">
                                            <div v-for="rd,rdidx in item.receiving_dates" v-bind:key="rdidx" style="display: block; margin: 5px;" v-if="rd">
                                                <div class="box" variant="primary" style="font-size: 11px;">{{rd}}</div>
                                            </div>
                                        </td>
                                        <td class="srrv"
    v-if="['admin'].includes(userDetails.userrole)"
    style="">
    <b-input
        :disabled="isItemDisabled(item)"
        readonly 
        size="sm" 
        v-model="item.total_fob_price" 
        type="number">
    </b-input>
</td>
<td class="srrv"
    v-if="['admin'].includes(userDetails.userrole)"
    style="">
    <b-input
        :disabled="isItemDisabled2(item)"
        size="sm" 
        v-model="item.data.tariff" 
        type="number">
    </b-input>
</td>
<td class="srrv"
    v-if="['admin'].includes(userDetails.userrole)"
    style="">
    <b-input
        :disabled="isItemDisabled2(item)"
        size="sm" 
        v-model="item.data.ocean_freight" 
        type="number">
    </b-input>
</td>
<td class="srrv"
    v-if="['admin'].includes(userDetails.userrole)"
    style="">
    <b-input
        :disabled="isItemDisabled2(item)"
        size="sm" 
        v-model="item.data.inland_freight" 
        type="number">
    </b-input>
</td>
<td class="srrv"
    v-if="['admin'].includes(userDetails.userrole)"
    style="">
    <b-input
        :disabled="isItemDisabled2(item)"
        size="sm" 
        v-model="item.data.other_cost" 
        type="number"
        readonly
        style="background-color: #f0f0f0;">
    </b-input>
</td>
<td class="srrv"
    v-if="['admin'].includes(userDetails.userrole)"
    style="">
    <b-input
        size="sm"
        v-model="item.data.landed"
        type="number"
        readonly
        :value="calculateLandedPrice(item)"
        style="background-color: #f0f0f0;">
    </b-input>
</td>
                                        <td class="srrv"></td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #9ec5ef;">
                                            <date-picker
                                                v-model="item.data.merch_etd"
                                                format="MM-DD-YYYY"
                                                valueType="format"
                                                style="padding: 4px; font-size: 11px; text-align: center; border: 1px solid gray; width: 130px;">
                                            </date-picker>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #9ec5ef;">
                                            <date-picker
                                                v-model="item.data.merch_invoice_date"
                                                format="MM-DD-YYYY"
                                                valueType="format"
                                                style="padding: 4px; font-size: 11px; text-align: center; border: 1px solid gray; width: 130px;">
                                            </date-picker>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #9ec5ef;">
                                            <b-input size="sm" v-model="item.data.merch_invoice_num"></b-input>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #9ec5ef;">
                                            <date-picker
                                                v-model="item.data.merch_payment_due_date"
                                                format="MM-DD-YYYY"
                                                valueType="format"
                                                style="padding: 4px; font-size: 11px; text-align: center; border: 1px solid gray; width: 130px;">
                                            </date-picker>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #9ec5ef;">
                                            <b-input size="sm" v-model="item.total_fob_price" type="number" readonly></b-input>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #9ec5ef;">
                                            <b-input size="sm" v-model="item.data.merch_pym_1_amt" type="number"></b-input>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: 9ec5ef;">
                                            <date-picker
                                                v-model="item.data.merch_pym_1_date"
                                                format="MM-DD-YYYY"
                                                valueType="format"
                                                style="padding: 4px; font-size: 11px; text-align: center; border: 1px solid gray; width: 130px;">
                                            </date-picker>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #9ec5ef;">
                                            <b-input size="sm" v-model="item.data.merch_pym_2_amt" type="number"></b-input>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #9ec5ef;">
                                            <date-picker
                                                v-model="item.data.merch_pym_2_date"
                                                format="MM-DD-YYYY"
                                                valueType="format"
                                                style="padding: 4px; font-size: 11px; text-align: center; border: 1px solid gray; width: 130px;">
                                            </date-picker>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #9ec5ef;">
                                            {{
                                                (
                                                    (parseFloat(item.total_fob_price) || 0.0) -
                                                    (
                                                        (parseFloat(item.data.merch_pym_1_amt) || 0.0) + 
                                                        (parseFloat(item.data.merch_pym_2_amt) || 0.0)
                                                    )
                                                ).toFixed(2)
                                            }}
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #9ec5ef;">
                                            <b-form-select size="sm" :options="pms" v-model="item.data.merch_payment_method"></b-form-select>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #d1d1d1;">
                                            <b-input size="sm" v-model="item.data.container_num"></b-input>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #d1d1d1;">
                                            <b-input size="sm" v-model="item.data.container_bl_num"></b-input>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #d1d1d1;">
                                            <date-picker
                                                v-model="item.data.container_freight_inv_date"
                                                format="MM-DD-YYYY"
                                                valueType="format"
                                                style="padding: 4px; font-size: 11px; text-align: center; border: 1px solid gray; width: 130px;">
                                            </date-picker>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #d1d1d1;">
                                            <b-input size="sm" v-model="item.data.container_freight_inv_num"></b-input>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #d1d1d1;">
                                            <b-input size="sm" v-model="item.data.container_freight_company"></b-input>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #d1d1d1;">
                                            <b-input size="sm" v-model="item.data.ocean_freight" type="number" readonly></b-input>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #d1d1d1;">
                                            <date-picker
                                                v-model="item.data.container_paid_date"
                                                format="MM-DD-YYYY"
                                                valueType="format"
                                                style="padding: 4px; font-size: 11px; text-align: center; border: 1px solid gray; width: 130px;">
                                            </date-picker>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #d1d1d1;">
                                            <b-form-select size="sm" :options="pms" v-model="item.data.container_payment_method"></b-form-select>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #94ffad;">
                                            <b-input size="sm" v-model="item.data.tariff" type="number" readonly></b-input>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #94ffad;">
                                            <date-picker
                                                v-model="item.data.tariff_paid_date"
                                                format="MM-DD-YYYY"
                                                valueType="format"
                                                style="padding: 4px; font-size: 11px; text-align: center; border: 1px solid gray; width: 130px;">
                                            </date-picker>
                                        </td>

                                         <td v-if="isDetailsExpanded" class="srrv" style="background: lightcyan;">
                                            <b-input size="sm" v-model="item.data.tariff_broker_fees" type="number"></b-input>
                                        </td>
                                         <td v-if="isDetailsExpanded" class="srrv" style="background: lightcyan;">
                                            <b-input size="sm" v-model="item.data.isf_flling" type="number"></b-input>
                                        </td>

                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #FC7474;">
                                            <b-input size="sm" v-model="item.data.dmrg_charges" type="number"></b-input>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #FC7474;">
                                            <date-picker
                                                v-model="item.data.dmrg_paid_date"
                                                format="MM-DD-YYYY"
                                                valueType="format"
                                                style="padding: 4px; font-size: 11px; text-align: center; border: 1px solid gray; width: 130px;">
                                            </date-picker>
                                        </td>
                                       
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #FC7474;">
                                            <b-input size="sm" v-model="item.data.tariff_handling_charges" type="number"></b-input>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #FC7474;">
                                            <b-input size="sm" v-model="item.data.tariff_detention_charges" type="number"></b-input>
                                        </td>

                                        
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #dfcdff;">
                                            <date-picker
                                                v-model="item.data.truck_inv_date"
                                                format="MM-DD-YYYY"
                                                valueType="format"
                                                style="padding: 4px; font-size: 11px; text-align: center; border: 1px solid gray; width: 130px;">
                                            </date-picker>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #dfcdff;">
                                            <b-input size="sm" v-model="item.data.truck_company"></b-input>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #dfcdff;">
                                            <b-input size="sm" v-model="item.data.truck_inv_num"></b-input>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #dfcdff;">
                                            <b-input size="sm" v-model="item.data.inland_freight" type="number" readonly></b-input>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #dfcdff;">
                                            <date-picker
                                                v-model="item.data.truck_paid_date"
                                                format="MM-DD-YYYY"
                                                valueType="format"
                                                style="padding: 4px; font-size: 11px; text-align: center; border: 1px solid gray; width: 130px;">
                                            </date-picker>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #dfcdff;">
                                            <b-form-select size="sm" :options="pms" v-model="item.data.truck_payment_method"></b-form-select>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #ffb6b6;">
                                            COMMENTS
                                        </td>
                                        <td class="srrv">
                                            <b-button
                                                size="sm"
                                                variant="outline-success"
                                                v-if="(item.product_skus || []).length > 0 || isAdmin"
                                                @click="view_item(item)"
                                                v-b-tooltip.hover
                                                title="VIEW ITEMS">
                                                <b-icon icon="eye-fill" aria-hidden="true"></b-icon>
                                            </b-button>

                                            <!-- Product Detail Button - FIXED: Better handling -->
                                            <b-button 
                                                size="sm" 
                                                variant="outline-info" 
                                                @click="showProductDetailModal(item)"
                                                v-b-tooltip.hover 
                                                title="VIEW PRODUCT DETAILS"
                                                :disabled="!item || !item.product_skus || item.product_skus.length === 0"
                                            >
                                                <b-icon icon="grid-3x3-gap-fill" aria-hidden="true"></b-icon>
                                            </b-button>

                                            <b-button 
                                                size="sm" 
                                                variant="outline-primary" 
                                                v-if="['admin', 'officemanager'].includes(packet.userDetails.userrole)" 
                                                @click="update_container_order(item)" 
                                                v-b-tooltip.hover 
                                                title="SAVE">
                                                <b-icon icon="check-square" aria-hidden="true"></b-icon>
                                            </b-button>

                                            <b-button
                                                size="sm"
                                                variant="outline-info"
                                                @click="generateContainerPDF(item)"
                                                :disabled="shouldDisableButtons(item)"
                                                v-b-tooltip.hover
                                                :title="getButtonTooltip(item)">
                                                <b-icon icon="file-earmark-pdf" aria-hidden="true"></b-icon>
                                            </b-button>

                                            <b-button
                                                size="sm"
                                                variant="outline-warning"
                                                @click="showEmailModal(item)"
                                                :disabled="shouldDisableButtons(item)"
                                                v-b-tooltip.hover
                                                :title="getButtonTooltip(item)">
                                                <b-icon icon="envelope" aria-hidden="true"></b-icon>
                                            </b-button>

                                            <b-button
                                                size="sm"
                                                variant="outline-danger"
                                                v-if="packet.userDetails.userrole == 'admin'"
                                                @click="delete_order(item)"
                                                v-b-tooltip.hover
                                                :title="item.data.status === 7 ? 'DELETE ORDER' : 'Only archived orders can be deleted'"
                                                :disabled="item.data.status !== 7">
                                                <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
                                            </b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import mappings from '@/utilities/mappings'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import VueSimpleSuggest from 'vue-simple-suggest'
    import 'vue-simple-suggest/dist/styles.css'
    import { BIconFunnelFill } from 'bootstrap-vue'

    import ContainerOrderItems from "@/components/VendorOrders/ContainerOrderItems"
    import ProductDetailModal from "@/components/VendorOrders/ProductDetailModal"

    export default {
        name: "ListContainerOrders",
        props: [],
        components: {
            flatPickr, 
            Loading, 
            DatePicker, 
            VueSimpleSuggest, 
            ContainerOrderItems, 
            ProductDetailModal
        },
        data: function() {
            return {
                packet: {},
                items: [],
                items_being_loaded: null,
                vendorPOCounters: {},
                vendorContainerCounters: {},
                containerStatusFilter: null,
                currentDetailProductSku: null,
                currentDetailOrderData: null,
                showProductDetail: false, // FIXED: Added this flag
                statuses: [
                    {value: 1, text: "NEW"},
                    {value: 2, text: "ORDERED"},
                    {value: 3, text: "SCHEDULED"},
                    {value: 4, text: "PARTIAL"},
                    {value: 5, text: "RECEIVED"},
                    {value: 6, text: "COMPLETED"},
                    {value: 7, text: "ARCHIVED"},
                ],
                container_statuses: [
                    {value: 1, text: "BOOKING REQUEST"},
                    {value: 2, text: "BOOKED/ISF FILING"},
                    {value: 3, text: "IN-TRANSIT"},
                    {value: 4, text: "ARRIVAL NOTICE"},
                ],
                pms: [
                    {value: "CHECK", text: "CHECK"},
                    {value: "WIRE", text: "WIRE"},
                    {value: "CASH", text: "CASH"},
                ],
                container_order_id: null,
                container_order_vendor_id: null,
                create_new: false,
                container_status: null,
                status: null,
                vendor: null,
                search_keyword: null,
                date_range: [],
                page_size: 15,
                current_page: 1,
                sort_asc: false,
                isDetailsExpanded: false,
                userDetails: JSON.parse(localStorage.userDetails),
                category: null,
                emailForm: {
                    email: '',
                    subject: '',
                    message: '',
                    poNumber: '',
                    containerNumber: '',
                    vendorName: '',
                    itemsCount: 0,
                    containerOrderId: null
                },
                filtersVisible: false,
                isMobile: false,
                receiving_dropdown_locations: [],
            }
        },
        mounted() {
            this.handleResize()
            window.addEventListener('resize', this.handleResize)
            this.loadCountersFromStorage()
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.handleResize)
            this.saveCountersToStorage()
        },
        computed: {
            calculateOtherCost: function(item) {
                if (!item || !item.data) return 0;
                
                const dmrgCharges = parseFloat(item.data.dmrg_charges) || 0;
                const handlingCharges = parseFloat(item.data.tariff_handling_charges) || 0;
                const detentionCharges = parseFloat(item.data.tariff_detention_charges) || 0;
                const totalFines = dmrgCharges + handlingCharges + detentionCharges;
                
                const brokerFees = parseFloat(item.data.tariff_broker_fees) || 0;
                const isfFilling = parseFloat(item.data.isf_flling) || 0;
                
                const otherCost = totalFines + brokerFees + isfFilling;
                
                this.$set(item.data, 'other_cost', otherCost);
                
                return otherCost;
            },
            containerStatusFilterOptions: function() {
                return [
                    { value: null, text: 'ALL' },
                    ...this.container_statuses
                ];
            },
            isAdmin() {
                return this.packet.userDetails.userrole === 'admin';
            },
            filter: function() {
                let that = this;

                if (that.vendor || that.status || that.category || that.containerStatusFilter || (that.date_range[0] != null) || (that.search_keyword || '').length >= 2) {
                    that.current_page = 1;
                }

                let items = this.items.filter(function(d) {
                    that.calculateLandedPrice(d);
                    return (
                        ((that.vendor) ? d.data.vendor_id == that.vendor : true ) &&
                        ((that.category) ? (d.categories || []).includes(that.category) : true ) &&
                        ((that.containerStatusFilter) ? d.data.container_status == that.containerStatusFilter : true ) &&
                        ((!that.status) ? [1, 2, 3, 4].includes(d.data.status) : (that.status) ? d.data.status == that.status : true ) &&
                        ((that.search_keyword) ? (d.data.po_number || '').toLowerCase().includes(that.search_keyword.toLowerCase()) : true ) &&
                        ((that.date_range[0] != null) ? d.data.final_eta >= that.date_range[0] && d.data.final_eta <= that.date_range[1] : true )
                    )
                }).filter((row, index) => {
                    let start = (that.current_page-1)*that.page_size;
                    let end = that.current_page*that.page_size;
                    if(index >= start && index < end) return true;
                });
                return items
            },
            bill_to_locations() {
                const excludedShipTo = ['All', 'ONLINE SALES', 'OUT OF STOCK', 'MECCA SHIPPING', '9TH ST ', '101 WH', 'FOLCROFT'];
                const allLocations = this.packet.locations ? this.packet.locations.filter(d => d.text != 'All') : [];

                let shipToLocations = allLocations
                    .filter(loc => !excludedShipTo.includes(loc.text))
                    .map(this.replaceMecca);

                const meccaWholesaleOption = { value: 'MECCA_WHOLESALE', text: 'MECCA WHOLESALE', isMecca: true };
                if (!shipToLocations.find(l => l.text === 'MECCA WHOLESALE')) {
                    shipToLocations.unshift(meccaWholesaleOption);
                }

                const userLocationId = this.packet.userDetails ? this.packet.userDetails.properties.location_id : null;
                const isAdmin = this.packet.userDetails ? this.packet.userDetails.userrole === 'admin' : false;
                if (!isAdmin && userLocationId) {
                    shipToLocations = shipToLocations.filter(d => d.value == userLocationId);
                }

                return shipToLocations;
            },
            ship_to_locations() {
                const excludedShipTo = ['All', 'ONLINE SALES', 'OUT OF STOCK', 'MECCA SHIPPING'];
                const allLocations = this.packet.locations ? this.packet.locations.filter(d => d.text != 'All') : [];

                let shipToLocations = allLocations
                    .filter(loc => !excludedShipTo.includes(loc.text))
                    .map(this.replaceMecca);

                const warehouseLocations = ['9TH ST ', '101 WH', 'FOLCROFT'];
                const hasMeccaWholesale = shipToLocations.some(loc => loc.text === 'MECCA WHOLESALE');

                if (!hasMeccaWholesale) {
                    shipToLocations = shipToLocations.filter(loc =>
                        !warehouseLocations.some(wh => loc.text.includes(wh))
                    );

                    const meccaOption = allLocations.find(loc =>
                        warehouseLocations.some(wh => loc.text.includes(wh))
                    );

                    if (meccaOption) {
                        shipToLocations.unshift({
                            value: 'MECCA_WHOLESALE',
                            text: 'MECCA WHOLESALE',
                            isMecca: true
                        });
                    }
                }

                const userLocationId = this.packet.userDetails ? this.packet.userDetails.properties.location_id : null;
                const isAdmin = this.packet.userDetails ? this.packet.userDetails.userrole === 'admin' : false;
                if (!isAdmin && userLocationId) {
                    shipToLocations = shipToLocations.filter(d => d.value == userLocationId);
                }

                return shipToLocations;
            },
            vendorName() {
                if (!this.vendor) return '';
                const vendorObj = this.packet.vendors ? this.packet.vendors.find(v => v.value === this.vendor) : null;
                return vendorObj ? vendorObj.text : '';
            }
        },
        methods: {
            // ===== FIXED: Show Product Detail Modal =====
            showProductDetailModal(item) {
                console.log('Opening product detail modal with item:', item);
                
                // Check if item has product_skus and at least one product
                if (!item || !item.product_skus || item.product_skus.length === 0) {
                    this.$bvToast.toast("No products found in this container order", { 
                        title: "Info", 
                        variant: "info" 
                    });
                    return;
                }
                
                // Reset data first to ensure clean state
                this.currentDetailProductSku = null;
                this.currentDetailOrderData = null;
                this.showProductDetail = false;
                
                // Use nextTick to ensure DOM updates
                this.$nextTick(() => {
                    // Set the data
                    this.currentDetailOrderData = item;
                    this.currentDetailProductSku = item.product_skus[0].product_sku || item.product_skus[0].sku;
                    this.showProductDetail = true;
                    
                    console.log('Set product detail data:', {
                        sku: this.currentDetailProductSku,
                        orderData: this.currentDetailOrderData
                    });
                    
                    // Show the modal after data is set
                    this.$nextTick(() => {
                        this.$bvModal.show('modal-product-detail');
                    });
                });
            },

            // ===== FIXED: Handle modal hidden =====
            handleProductModalHidden() {
                console.log('Product modal hidden, resetting data');
                // Don't reset immediately to avoid flash
                setTimeout(() => {
                    this.showProductDetail = false;
                    this.currentDetailProductSku = null;
                    this.currentDetailOrderData = null;
                    console.log('Product detail data reset');
                }, 300);
            },

            // ===== View Single Product =====
            viewProductDetail(sku) {
                // Close current modal and open single product detail
                this.$bvModal.hide('modal-product-detail');
                this.currentDetailProductSku = sku;
                this.currentDetailOrderData = null;
                // Reopen the modal after a short delay
                setTimeout(() => {
                    this.$bvModal.show('modal-product-detail');
                }, 300);
            },

            // ===== Open Full Product Detail =====
            openProductDetail(sku) {
                // This can be used to open a full product detail page
                // For now, just show a toast
                this.$bvToast.toast(
                    `Opening full details for SKU: ${sku}`,
                    { title: "Info", variant: "info" }
                );
                // You can redirect to product page or open another modal
            },

            calculateTotalFines: function(item) {
                if (!item || !item.data) return '0.00';
                
                const dmrgCharges = parseFloat(item.data.dmrg_charges) || 0;
                const handlingCharges = parseFloat(item.data.tariff_handling_charges) || 0;
                const detentionCharges = parseFloat(item.data.tariff_detention_charges) || 0;
                
                const total = dmrgCharges + handlingCharges + detentionCharges;
                return total.toFixed(2);
            },
            // ===== DATE NORMALIZATION METHODS =====
            normalizeDates: function(items) {
                if (!items || !Array.isArray(items)) return items;
                
                items.forEach(item => {
                    if (item.data) {
                        if (!item.data.ordered_date_display) {
                            this.$set(item.data, 'ordered_date_display', null);
                        }
                        if (!item.data.schedule_date_display) {
                            this.$set(item.data, 'schedule_date_display', null);
                        }
                        
                        if (item.data.ordered_date) {
                            const parts = item.data.ordered_date.split('-');
                            if (parts.length === 3 && parts[0].length === 4) {
                                const formattedDate = `${parts[1]}-${parts[2]}-${parts[0]}`;
                                item.data.ordered_date_display = formattedDate;
                            } else {
                                item.data.ordered_date_display = item.data.ordered_date;
                            }
                        } else {
                            item.data.ordered_date_display = null;
                        }

                        if (item.data.schedule_date) {
                            const parts = item.data.schedule_date.split('-');
                            if (parts.length === 3 && parts[0].length === 4) {
                                const formattedDate = `${parts[1]}-${parts[2]}-${parts[0]}`;
                                item.data.schedule_date_display = formattedDate;
                            } else {
                                item.data.schedule_date_display = item.data.schedule_date;
                            }
                        } else {
                            item.data.schedule_date_display = null;
                        }
                    }
                });
                
                return items;
            },

            formatDateForBackend(dateString) {
                if (!dateString) return null;
                const parts = dateString.split('-');
                if (parts.length === 3 && parts[0].length === 4) {
                    return dateString;
                }
                if (parts.length === 3 && parts[0].length === 2) {
                    return `${parts[2]}-${parts[0]}-${parts[1]}`;
                }
                return dateString;
            },

            handleOrderedDateChange(item) {
                if (item.data.ordered_date_display && item.data.status !== 2) {
                    this.$set(item.data, 'status', 2);
                    this.$set(item.data, 'ordered_date', item.data.ordered_date_display);
                    
                    this.$bvToast.toast(
                        `Status automatically set to ORDERED`,
                        { title: "Status Updated", autoHideDelay: 1500, variant: "info" }
                    );
                }
            },

            handleScheduleDateChange(item) {
                if (item.data.schedule_date_display) {
                    this.$set(item.data, 'schedule_date', item.data.schedule_date_display);
                    
                    if (item.data.status !== 3) {
                        this.$set(item.data, 'status', 3);
                        this.$set(item.data, 'container_status', 1);
                        this.$bvToast.toast(
                            `Status set to SCHEDULED and Container Status set to BOOKING REQUEST`,
                            { title: "Status Updated", autoHideDelay: 1500, variant: "info" }
                        );
                    } else {
                        this.$bvToast.toast(
                            `Schedule date set to ${item.data.schedule_date_display}`,
                            { title: "Schedule Date Updated", autoHideDelay: 1500, variant: "success" }
                        );
                    }
                }
            },

            handleContainerStatusChange: function(item) {
                if (item.data.container_status === 3) {
                    if (!item.data.final_eta) {
                        const today = new Date();
                        const mm = String(today.getMonth() + 1).padStart(2, '0');
                        const dd = String(today.getDate()).padStart(2, '0');
                        const yyyy = today.getFullYear();
                        const formattedDate = `${mm}-${dd}-${yyyy}`;
                        
                        this.$set(item.data, 'final_eta', formattedDate);
                        
                        this.$bvToast.toast(
                            `Arrival ETA set to ${formattedDate}`,
                            { title: "ETA Updated", autoHideDelay: 1500, variant: "success" }
                        );
                    }
                }
            },

            handleStatusChange: function(item) {
                if (item.data.status === 2) {
                    if (!item.data.ordered_date_display) {
                        const today = new Date();
                        const mm = String(today.getMonth() + 1).padStart(2, '0');
                        const dd = String(today.getDate()).padStart(2, '0');
                        const yyyy = today.getFullYear();
                        const formattedDate = `${mm}-${dd}-${yyyy}`;
                        
                        this.$set(item.data, 'ordered_date_display', formattedDate);
                        this.$set(item.data, 'ordered_date', formattedDate);
                        
                        this.$bvToast.toast(
                            `Ordered date set to ${formattedDate}`,
                            { title: "Ordered", autoHideDelay: 2000, variant: "success" }
                        );
                    }
                }
                
                if (item.data.status === 3) {
                    if (Array.isArray(item.product_skus) && item.product_skus.length === 0) {
                        this.$bvToast.toast(
                            "Cannot set status to SCHEDULED when there are 0 items in the container order.",
                            { title: "Validation Error", autoHideDelay: 3000, variant: "warning" }
                        );
                        this.$set(item.data, 'status', 2);
                        return;
                    }
                    
                    if (!item.data.schedule_date_display) {
                        const today = new Date();
                        const mm = String(today.getMonth() + 1).padStart(2, '0');
                        const dd = String(today.getDate()).padStart(2, '0');
                        const yyyy = today.getFullYear();
                        const formattedDate = `${mm}-${dd}-${yyyy}`;
                        
                        this.$set(item.data, 'schedule_date_display', formattedDate);
                        this.$set(item.data, 'schedule_date', formattedDate);
                        
                        this.$bvToast.toast(
                            `Schedule date set to ${formattedDate}`,
                            { title: "Scheduled", autoHideDelay: 2000, variant: "success" }
                        );
                    }
                    
                    if (!item.data.container_status || item.data.container_status === 0) {
                        this.$set(item.data, 'container_status', 1);
                        this.$bvToast.toast(
                            `Container Status set to BOOKING REQUEST`,
                            { title: "Container Status Updated", autoHideDelay: 1500, variant: "info" }
                        );
                    }
                }
            },

            prevPage: function() {
                if (this.current_page > 1) {
                    this.current_page--;
                }
            },
            nextPage: function() {
                if ((this.current_page * this.page_size) < this.items.length) {
                    this.current_page++;
                }
            },
            
            getFilteredReceivingLocations(item) {
                const shipToLocation = item.data.ship_to;

                if (!shipToLocation) {
                    return this.receiving_dropdown_locations || [];
                }

                const shipToText = this.getLocationText(shipToLocation);

                if (shipToText === 'MECCA WHOLESALE') {
                    return (this.receiving_dropdown_locations || []).filter(loc =>
                        ['9TH ST ', '101 WH', 'FOLCROFT'].some(whLocation =>
                            loc.text.includes(whLocation)
                        )
                    );
                } else {
                    return (this.receiving_dropdown_locations || []).filter(loc =>
                        loc.value === shipToLocation || loc.text === shipToText
                    );
                }
            },
            
            handleResize() {
                this.isMobile = window.innerWidth < 768
            },
            shouldDisableButtons(item) {
                const hasItems = Array.isArray(item.product_skus) && item.product_skus.length > 0;
                if (!hasItems) {
                    return true;
                }

                if (!this.isAdmin && !hasItems) {
                    return true;
                }

                if (!item.data.po_number || !item.data.vendor_id) {
                    return true;
                }

                return false;
            },
            getButtonTooltip(item) {
                const hasItems = Array.isArray(item.product_skus) && item.product_skus.length > 0;

                if (!hasItems) {
                    return "Cannot generate PDF/Email for empty container orders";
                }

                if (!this.isAdmin && !hasItems) {
                    return "Non-admin users cannot generate PDF/Email for empty containers";
                }

                if (!item.data.po_number || !item.data.vendor_id) {
                    return "PO number and vendor are required";
                }

                return "GENERATE PDF";
            },
            getVendorName: function(vendorId) {
                if (!vendorId) return '';
                const vendorObj = this.packet.vendors ? this.packet.vendors.find(v => v.value === vendorId) : null;
                return vendorObj ? vendorObj.text : '';
            },
            getLocationText: function(locationValue) {
                if (!locationValue) return '';

                if (locationValue === 'MECCA_WHOLESALE') {
                    return 'MECCA WHOLESALE';
                }

                const billToLoc = this.bill_to_locations ? this.bill_to_locations.find(loc => loc.value === locationValue) : null;
                if (billToLoc) return billToLoc.text;

                const shipToLoc = this.ship_to_locations ? this.ship_to_locations.find(loc => loc.value === locationValue) : null;
                if (shipToLoc) return shipToLoc.text;

                const allLoc = this.packet.locations ? this.packet.locations.find(loc => loc.value === locationValue) : null;
                return allLoc ? allLoc.text : '';
            },
            generateContainerPDF(item) {
                const that = this;

                if (!item.data.po_number || !item.data.vendor_id) {
                    this.$bvToast.toast("PO number and vendor are required to generate PDF", {
                        title: "Error",
                        autoHideDelay: 1500,
                        variant: "danger"
                    });
                    return;
                }

                const vendorName = this.getVendorName(item.data.vendor_id);
                const billingLocation = this.getLocationText(item.data.bill_to);
                const shippingLocation = this.getLocationText(item.data.ship_to);
                const receivingLocation = this.getLocationText(item.data.receiving_location);
                const statusObj = this.statuses.find(s => s.value === item.data.status);
                const statusText = statusObj ? statusObj.text : 'NEW';

                let itemsForPDF = [];
                
                if (item.product_skus && item.product_skus.length > 0) {
                    if (item.product_skus[0] && item.product_skus[0].quantity_ordered !== undefined) {
                        itemsForPDF = item.product_skus.map(product => ({
                            sku: product.product_sku,
                            name: product.product_name,
                            quantity: product.quantity_ordered || 1
                        }));
                    } else if (item.product_skus[0] && (item.product_skus[0].quantity || item.product_skus[0].qty)) {
                        itemsForPDF = item.product_skus.map(product => ({
                            sku: product.product_sku,
                            name: product.product_name,
                            quantity: product.quantity || product.qty || 1
                        }));
                    } else if (item.quantity_ordered && item.product_skus) {
                        const quantityPerItem = Math.floor(Number(item.quantity_ordered) / item.product_skus.length);
                        itemsForPDF = item.product_skus.map(product => ({
                            sku: product.product_sku,
                            name: product.product_name,
                            quantity: quantityPerItem > 0 ? quantityPerItem : 1
                        }));
                    } else {
                        itemsForPDF = (item.product_skus || []).map(product => ({
                            sku: product.product_sku,
                            name: product.product_name,
                            quantity: 1
                        }));
                    }
                } else {
                    itemsForPDF = [];
                }

                const pdfData = {
                    po_number: item.data.po_number,
                    container_number: item.data.container_num,
                    vendor: vendorName,
                    receiving_location: receivingLocation,
                    shipping_location: shippingLocation,
                    billing_location: billingLocation,
                    eta: item.data.final_eta,
                    invoice_number: item.data.invoice_number,
                    status: statusText,
                    items: itemsForPDF,
                    send_email: false,
                    email: '',
                    order_type: 'container'
                };

                this.items_being_loaded = true;

                Requestor.postSyncP(
                    "/api/vendor/generate_container_pdf/",
                    pdfData,
                    this,
                    function(response) {
                        that.items_being_loaded = false;

                        if (response.data && response.data.error) {
                            that.$bvToast.toast(response.data.error, {
                                title: "Error",
                                autoHideDelay: 1500,
                                variant: "danger"
                            });
                            return;
                        }

                        try {
                            const blob = new Blob([response.data], { type: "application/pdf" });
                            const pdfUrl = URL.createObjectURL(blob);
                            window.open(pdfUrl, "_blank");

                            that.$bvToast.toast("PDF generated successfully!", {
                                title: "Success",
                                autoHideDelay: 1500,
                                variant: "success"
                            });
                        } catch (err) {
                            console.error("Error processing PDF blob:", err);
                            that.$bvToast.toast("Failed to display PDF", {
                                title: "Error",
                                autoHideDelay: 1500,
                                variant: "danger"
                            });
                        }
                    },
                    function(error) {
                        that.items_being_loaded = false;
                        console.error("PDF generation API error:", error);
                        that.$bvToast.toast("Failed to generate PDF", {
                            title: "Error",
                            autoHideDelay: 1500,
                            variant: "danger"
                        });
                    }
                );
            },
            showEmailModal(item) {
                if (!item.data.po_number || !item.data.vendor_id) {
                    this.$bvToast.toast("PO number and vendor are required to send email", {
                        title: "Error",
                        autoHideDelay: 1500,
                        variant: "danger"
                    });
                    return;
                }

                this.emailForm = {
                    email: '',
                    subject: `Container Purchase Order: ${item.data.po_number}`,
                    message: `Dear Vendor,\n\nPlease find attached container purchase order ${item.data.po_number} (Container: ${item.data.container_num}).\n\nThank you,\nFurniture Mecca`,
                    poNumber: item.data.po_number,
                    containerNumber: item.data.container_num,
                    vendorName: this.getVendorName(item.data.vendor_id),
                    itemsCount: (item.product_skus || []).length,
                    containerOrderId: item.id
                };

                this.$bvModal.show('email-container-po-modal');
            },
            sendContainerPOEmail() {
                const that = this;
                const item = this.items.find(i => i.id === this.emailForm.containerOrderId);

                if (!item) {
                    this.$bvToast.toast("Order not found", {
                        title: "Error",
                        autoHideDelay: 1500,
                        variant: "danger"
                    });
                    return;
                }

                const vendorName = this.getVendorName(item.data.vendor_id);
                const billingLocation = this.getLocationText(item.data.bill_to);
                const shippingLocation = this.getLocationText(item.data.ship_to);
                const receivingLocation = this.getLocationText(item.data.receiving_location);
                const statusObj = this.statuses.find(s => s.value === item.data.status);
                const statusText = statusObj ? statusObj.text : 'NEW';

                let itemsForEmail = [];
                
                if (item.product_skus && item.product_skus.length > 0) {
                    if (item.product_skus[0] && item.product_skus[0].quantity_ordered !== undefined) {
                        itemsForEmail = item.product_skus.map(product => ({
                            sku: product.product_sku,
                            name: product.product_name,
                            quantity: product.quantity_ordered || 1
                        }));
                    } else if (item.product_skus[0] && (item.product_skus[0].quantity || item.product_skus[0].qty)) {
                        itemsForEmail = item.product_skus.map(product => ({
                            sku: product.product_sku,
                            name: product.product_name,
                            quantity: product.quantity || product.qty || 1
                        }));
                    } else if (item.quantity_ordered && item.product_skus) {
                        const quantityPerItem = Math.floor(Number(item.quantity_ordered) / item.product_skus.length);
                        itemsForEmail = item.product_skus.map(product => ({
                            sku: product.product_sku,
                            name: product.product_name,
                            quantity: quantityPerItem > 0 ? quantityPerItem : 1
                        }));
                    } else {
                        itemsForEmail = (item.product_skus || []).map(product => ({
                            sku: product.product_sku,
                            name: product.product_name,
                            quantity: 1
                        }));
                    }
                } else {
                    itemsForEmail = [];
                }

                const emailData = {
                    po_number: item.data.po_number,
                    container_number: item.data.container_num,
                    vendor: vendorName,
                    receiving_location: receivingLocation,
                    shipping_location: shippingLocation,
                    billing_location: billingLocation,
                    eta: item.data.final_eta,
                    invoice_number: item.data.invoice_number,
                    status: statusText,
                    items: itemsForEmail,
                    send_email: true,
                    email: this.emailForm.email,
                    subject: this.emailForm.subject,
                    message: this.emailForm.message,
                    order_type: 'container'
                };

                this.items_being_loaded = true;

                Requestor.postSyncP(
                    "/api/vendor/generate_container_pdf/",
                    emailData,
                    this,
                    function(response) {
                        that.items_being_loaded = false;

                        if (response.data && response.data.error) {
                            that.$bvToast.toast(response.data.error, {
                                title: "Error",
                                autoHideDelay: 1500,
                                variant: "danger"
                            });
                            return;
                        }

                        that.$bvToast.toast(`Email sent successfully to ${that.emailForm.email}`, {
                            title: "Success",
                            autoHideDelay: 2000,
                            variant: "success"
                        });

                        that.$bvModal.hide('email-container-po-modal');
                        that.resetEmailForm();
                    },
                    function(error) {
                        that.items_being_loaded = false;
                        console.error("Email sending error:", error);
                        that.$bvToast.toast("Failed to send email", {
                            title: "Error",
                            autoHideDelay: 1500,
                            variant: "danger"
                        });
                    }
                );
            },
            resetEmailForm() {
                this.emailForm = {
                    email: '',
                    subject: '',
                    message: '',
                    poNumber: '',
                    containerNumber: '',
                    vendorName: '',
                    itemsCount: 0,
                    containerOrderId: null
                };
            },
            getStatusText(item) {
                const statusObj = this.statuses.find(s => s.value === item.data.status);
                return statusObj ? statusObj.text : 'NEW';
            },
            replaceMecca: function(location) {
                if (location.text === '9TH ST , 101 WH, FOLCROFT') {
                    return { ...location, text: 'MECCA WHOLESALE', isMecca: true };
                }

                if (location.text && (location.text.includes('9TH ST ') || location.text.includes('101 WH') || location.text.includes('FOLCROFT'))) {
                    return { ...location, isMeccaLocation: true };
                }

                return location;
            },
            handleShipToChange: function(item) {
                const shipToLocation = item.data.ship_to;
                item.data.receiving_location = null;

                if (shipToLocation && shipToLocation !== 'MECCA_WHOLESALE') {
                    item.data.receiving_location = shipToLocation;
                }
            },
            handleBillToChange: function(item) {
                // Bill-to is now independent
            },
            isItemDisabled2(item) {
                const completedStatuses = [6, 7];

                if (this.packet.userDetails && this.packet.userDetails.userrole !== 'admin') {
                    return true;
                }

                if (completedStatuses.includes(item.data.status)) {
                    return true;
                }

                return false;
            },
            isItemDisabled(item) {
                const completedStatuses = [5, 6, 7];

                if (this.packet.userDetails && this.packet.userDetails.userrole === 'warehouseuser') {
                    return true;
                }

                if (completedStatuses.includes(item.data.status)) {
                    return true;
                }

                return false;
            },
            setupLocations: function() {
                if (!this.packet.locations) return;
                
                const allLocations = this.packet.locations.filter(d => d.text != 'All');
                const userLocationId = this.packet.userDetails ? this.packet.userDetails.properties.location_id : null;
                const isAdmin = this.packet.userDetails ? this.packet.userDetails.userrole === 'admin' : false;

                const excludedLocationTexts = [
                    'All', 'ONLINE SALES', 'OUT OF STOCK', 'MECCA SHIPPING'
                ];

                this.locations = allLocations
                    .filter(location => !excludedLocationTexts.includes(location.text))
                    .map(this.replaceMecca);

                if (!isAdmin && userLocationId) {
                    this.locations = this.locations.filter(d => d.value == userLocationId);
                }

                this.receiving_locations = allLocations
                    .filter(location => !excludedLocationTexts.includes(location.text))
                    .map(this.replaceMecca);

                this.filter_locations = [
                    { value: null, text: 'ALL' },
                    ...this.locations
                ];

                this.filter_receiving_locations = [
                    { value: null, text: 'ALL' },
                    ...this.receiving_locations
                ];

                const excludedReceiving = ['All', 'ONLINE SALES', 'OUT OF STOCK', 'MECCA SHIPPING', 'MECCA WHOLESALE'];
                this.receiving_dropdown_locations = allLocations
                    .filter(loc => !excludedReceiving.includes(loc.text))
                    .map(this.replaceMecca);

                if (!isAdmin && userLocationId) {
                    this.receiving_dropdown_locations = this.receiving_dropdown_locations.filter(d => d.value == userLocationId);
                }
            },
            autoSetOrderedStatus: function(item) {
                const hasValidPONumber = item.data.po_number && item.data.po_number !== "N/A" && item.data.po_number.trim() !== "";
                const hasValidContainerNumber = item.data.container_num && item.data.container_num !== "N/A" && item.data.container_num.trim() !== "";

                if (hasValidPONumber && hasValidContainerNumber && item.data.status === 1) {
                    item.data.status = 1;
                }
            },
            saveCountersToStorage() {
                try {
                    localStorage.setItem('vendorPOCounters', JSON.stringify(this.vendorPOCounters));
                    localStorage.setItem('vendorContainerCounters', JSON.stringify(this.vendorContainerCounters));
                } catch (e) {
                    console.warn('Failed to save counters to localStorage:', e);
                }
            },
            loadCountersFromStorage() {
                try {
                    const savedPOCounters = localStorage.getItem('vendorPOCounters');
                    const savedContainerCounters = localStorage.getItem('vendorContainerCounters');

                    if (savedPOCounters) {
                        this.vendorPOCounters = JSON.parse(savedPOCounters);
                    }

                    if (savedContainerCounters) {
                        this.vendorContainerCounters = JSON.parse(savedContainerCounters);
                    }
                } catch (e) {
                    console.warn('Failed to load counters from localStorage:', e);
                }
            },
            isWarehouseUser() {
                return this.packet.userDetails && this.packet.userDetails.userrole === 'warehouseuser';
            },
            calculateLandedPrice: function(item) {
                const totalFob = parseFloat(item.total_fob_price) || 0;
                const tariff = parseFloat(item.data.tariff) || 0;
                const oceanFreight = parseFloat(item.data.ocean_freight) || 0;
                const inlandFreight = parseFloat(item.data.inland_freight) || 0;
                const totalFines = parseFloat(item.data.total_fines) || 0;
                const otherCost = parseFloat(item.data.other_cost) || 0;
                
                let calculatedFines = totalFines;
                if (!calculatedFines) {
                    const dmrgCharges = parseFloat(item.data.dmrg_charges) || 0;
                    const handlingCharges = parseFloat(item.data.tariff_handling_charges) || 0;
                    const detentionCharges = parseFloat(item.data.tariff_detention_charges) || 0;
                    calculatedFines = dmrgCharges + handlingCharges + detentionCharges;
                    this.$set(item.data, 'total_fines', calculatedFines);
                }
                
                const brokerFees = parseFloat(item.data.tariff_broker_fees) || 0;
                const isfFilling = parseFloat(item.data.isf_flling) || 0;
                const calculatedOtherCost = calculatedFines + brokerFees + isfFilling;
                this.$set(item.data, 'other_cost', calculatedOtherCost);
                
                const landed = totalFob + tariff + oceanFreight + inlandFreight + calculatedOtherCost;
                
                item.data.landed = landed.toFixed(2);
                
                return landed.toFixed(2);
            },
            formatDateWithoutTime(dateString) {
                if (!dateString) return '';
                return moment(dateString).format('MM-DD-YYYY');
            },
            validateUniqueNumbers(item) {
                const poDuplicate = this.items.some(otherItem =>
                    otherItem.id !== item.id &&
                    otherItem.data.po_number === item.data.po_number
                );

                const containerDuplicate = this.items.some(otherItem =>
                    otherItem.id !== item.id &&
                    otherItem.data.container_num === item.data.container_num
                );

                if (poDuplicate) {
                    return "PO number already exists!";
                }

                if (containerDuplicate) {
                    return "Container number already exists!";
                }

                return null;
            },
            initializeCounters() {
                this.vendorPOCounters = {};
                this.vendorContainerCounters = {};

                this.items.forEach(item => {
                    if (item.data.vendor_id) {
                        const vendorObj = this.packet.vendors ? this.packet.vendors.find(v => v.value === item.data.vendor_id) : null;
                        const vendorName = vendorObj ? vendorObj.text : null;

                        if (vendorName) {
                            if (!this.vendorPOCounters[vendorName]) {
                                this.vendorPOCounters[vendorName] = 1000;
                            }
                            if (!this.vendorContainerCounters[vendorName]) {
                                this.vendorContainerCounters[vendorName] = 1000;
                            }

                            if (item.data.po_number) {
                                const match = item.data.po_number.match(/\d+$/);
                                if (match) {
                                    const number = parseInt(match[0]);
                                    if (number > this.vendorPOCounters[vendorName]) {
                                        this.vendorPOCounters[vendorName] = number;
                                    }
                                }
                            }

                            if (item.data.container_num) {
                                const match = item.data.container_num.match(/\d+$/);
                                if (match) {
                                    const number = parseInt(match[0]);
                                    if (number > this.vendorContainerCounters[vendorName]) {
                                        this.vendorContainerCounters[vendorName] = number;
                                    }
                                }
                            }
                        }
                    }
                });

                this.saveCountersToStorage();
            },
            generateOrderNumber(vendorName) {
                if (!vendorName) return "N/A";

                if (!this.vendorPOCounters[vendorName]) {
                    this.vendorPOCounters[vendorName] = 1000;
                } else {
                    this.vendorPOCounters[vendorName]++;
                }

                const newNumber = this.vendorPOCounters[vendorName];
                this.saveCountersToStorage();
                return `${vendorName}-${newNumber}`;
            },
            generateContainerNumber(vendorName) {
                if (!vendorName) return "N/A";

                if (!this.vendorContainerCounters[vendorName]) {
                    this.vendorContainerCounters[vendorName] = 1000;
                } else {
                    this.vendorContainerCounters[vendorName]++;
                }

                const newNumber = this.vendorContainerCounters[vendorName];
                this.saveCountersToStorage();
                return `${vendorName}-CTN-${newNumber}`;
            },
            onVendorSelected(item) {
                if (!item.data.vendor_id) return;

                const vendorObj = this.packet.vendors ? this.packet.vendors.find(v => v.value === item.data.vendor_id) : null;
                const vendorName = vendorObj ? vendorObj.text : null;

                if (!vendorName) return;

                const previousVendor = item._previousVendor;
                const vendorChanged = previousVendor && previousVendor !== item.data.vendor_id;
                
                const currentPONumber = item.data.po_number || "";
                const currentContainerNum = item.data.container_num || "";
                
                const needsNewPONumber = !currentPONumber || 
                                        currentPONumber === "N/A" ||
                                        (previousVendor && 
                                         currentPONumber.startsWith(previousVendor)) ||
                                        vendorChanged;

                const needsNewContainerNumber = !currentContainerNum || 
                                               currentContainerNum === "N/A" ||
                                               (previousVendor && 
                                                currentContainerNum.startsWith(previousVendor)) ||
                                               vendorChanged;

                if (needsNewPONumber) {
                    item.data.po_number = this.generateOrderNumber(vendorName);
                }

                if (needsNewContainerNumber) {
                    item.data.container_num = this.generateContainerNumber(vendorName);
                }

                item._previousVendor = vendorName;

                this.autoSetOrderedStatus(item);
                this.autoSetMeccaWholesaleLocations(item);
                
                this.saveCountersToStorage();
            },
            autoSetMeccaWholesaleLocations: function(item) {
                const meccaBillTo = this.bill_to_locations ? this.bill_to_locations.find(loc =>
                    loc.text === 'MECCA WHOLESALE' || loc.value === 'MECCA_WHOLESALE'
                ) : null;

                const meccaShipTo = this.ship_to_locations ? this.ship_to_locations.find(loc =>
                    loc.text === 'MECCA WHOLESALE' || loc.value === 'MECCA_WHOLESALE'
                ) : null;

                if (meccaBillTo) {
                    item.data.bill_to = meccaBillTo.value;
                }

                if (meccaShipTo) {
                    item.data.ship_to = meccaShipTo.value;

                    const defaultReceivingLoc = this.receiving_dropdown_locations ? this.receiving_dropdown_locations.find(loc =>
                        loc.text && loc.text.includes('9TH ST')
                    ) : null;

                    if (defaultReceivingLoc) {
                        item.data.receiving_location = defaultReceivingLoc.value;
                    }
                }
            },
            statusFromItemsCount: function(item) {
                if (Array.isArray(item.product_skus) && item.product_skus.length === 0) {
                    return this.no_items_status = this.statuses.map(item => ({
                        ...item,
                        disabled: !["NEW"].includes(item.text)
                    })).filter(item => !["ALL"].includes(item.text)) || [];
                }
                return this.statuses.filter(item => !["ALL"].includes(item.text)) || [];
            },
            getStatusOptions: function(item) {
                const currentStatus = item.data.status;

                const STATUS = {
                    NEW: 1,
                    ORDERED: 2,
                    SCHEDULED: 3,
                    PARTIAL: 4,
                    RECEIVED: 5,
                    COMPLETED: 6,
                    ARCHIVED: 7
                };

                if (Array.isArray(item.product_skus) && item.product_skus.length === 0) {
                    return this.statuses.map(status => ({
                        ...status,
                        disabled: status.value !== STATUS.ORDERED && status.value !== STATUS.ARCHIVED
                    })).filter(status => !["ALL"].includes(status.text)) || [];
                }

                let options = this.statuses.map(status => {
                    let disabled = false;

                    if ([STATUS.PARTIAL, STATUS.COMPLETED, STATUS.ARCHIVED].includes(currentStatus)) {
                        disabled = true;
                    } else if (currentStatus === STATUS.NEW) {
                        disabled = ![STATUS.ORDERED, STATUS.SCHEDULED, STATUS.ARCHIVED].includes(status.value);
                    } else if (currentStatus === STATUS.ORDERED) {
                        disabled = ![STATUS.ORDERED, STATUS.SCHEDULED, STATUS.ARCHIVED].includes(status.value);
                    } else if (currentStatus === STATUS.SCHEDULED) {
                        disabled = ![STATUS.SCHEDULED].includes(status.value);
                    } else if (currentStatus === STATUS.RECEIVED) {
                        disabled = ![STATUS.COMPLETED, STATUS.ARCHIVED].includes(status.value);
                    } else if (currentStatus === STATUS.PARTIAL) {
                        disabled = ![STATUS.RECEIVED, STATUS.COMPLETED, STATUS.ARCHIVED].includes(status.value);
                    }

                    return {
                        ...status,
                        disabled: disabled
                    };
                });

                return options.filter(status => !["ALL"].includes(status.text)) || [];
            },
            validateOrderNumber: function(item) {
                if (item.data.status >= 2) {
                    return item.data.po_number && item.data.po_number.trim() !== '';
                }
                return null;
            },
            handleEtaDateChange: function(item) {
                if (Array.isArray(item.product_skus) && item.product_skus.length === 0) {
                    this.$bvToast.toast(
                        "Cannot schedule container order with 0 items",
                        { title: "Validation Error", autoHideDelay: 3000, variant: "warning" }
                    );
                    item.data.final_eta = null;
                    return;
                }

                if (item.data.final_eta && item.data.status !== 3 && item.product_skus && item.product_skus.length > 0) {
                    item.data.status = 3;
                    this.$set(item.data, 'container_status', 1);
                    this.$bvToast.toast(
                        "Status set to SCHEDULED and Container Status set to BOOKING REQUEST",
                        { title: "Status Updated", autoHideDelay: 1500, variant: "info" }
                    );
                }
            },
            delete_order: function(item) {
                if (!item.id) {
                    this.$vex.dialog.alert(
                        { message: "PLEASE SAVE THE ORDER FIRST BEFORE DELETING IT." }
                    );
                    return
                }
                let data = { id: item.id };
                let that = this;
                let path = "/api/vendor/delete_container_order/"
                let s = function(response) {
                    if (response.data.error) {
                        that.$bvToast.toast(
                            response.data.error,
                            { title: "ERROR", autoHideDelay: 1500, variant: "danger" }
                        );
                    } else {
                        that.$bvToast.toast(
                            "DELETED",
                            { title: "SUCCESS", autoHideDelay: 1500, variant: "success" }
                        );
                        that.items = that.items.filter(function(d) { return d.id != item.id });
                    }
                    that.items_being_loaded = false
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred in deleting. Please try again.",
                        { title: "Error", autoHideDelay: 1500, variant: "danger" }
                    );
                    that.items_being_loaded = false
                }
                this.items_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            add_new_container_order: function() {
                let item = {
                    data: {
                        vendor_id: null,
                        po_number: "N/A",
                        invoice_number: null,
                        final_eta_time: null,
                        status: 1,
                        container_status: 1,
                        bill_to: null,
                        ship_to: null,
                        receiving_location: null,
                        tariff: 0,
                        isf_flling: 0,
                        ocean_freight: 0,
                        inland_freight: 0,
                        total_fines: 0,
                        transport_cost: 0,
                        other_cost: 0,
                        landed: 0,
                        ordered_date: null,
                        ordered_date_display: null,
                        schedule_date: null,
                        schedule_date_display: null
                    },
                    id: null,
                    status: 1,
                    created_at: null,
                    updated_at: null,
                    created_by: this.packet.userDetails ? this.packet.userDetails.username : '',
                    product_skus: [],
                    categories: [],
                    cubes: 0,
                    total_fob_price: 0,
                    received_items: 0,
                    remaining_items: 0,
                    _previousVendor: null
                };

                this.items.unshift(item);

                if (this.packet.vendors && this.packet.vendors.length > 0) {
                    setTimeout(() => {
                        const firstVendor = this.packet.vendors[0];
                        const vendorToSelect = firstVendor.value === null && this.packet.vendors.length > 1 
                            ? this.packet.vendors[1] 
                            : firstVendor;
                        
                        if (vendorToSelect && vendorToSelect.value) {
                            item.data.vendor_id = vendorToSelect.value;
                            this.onVendorSelected(item);
                        }
                    }, 100);
                }

                let data = item;
                let that = this;
                let path = "/api/vendor/create_container_order/";
                
                let s = function(response) {
                    if (response.data.error) {
                        that.$bvToast.toast(
                            response.data.error,
                            { title: "ERROR", autoHideDelay: 1500, variant: "danger" }
                        );
                        that.items = that.items.filter(d => d.id !== item.id);
                    } else {
                        that.$bvToast.toast(
                            "ADDED NEW ORDER",
                            { title: "SUCCESS", autoHideDelay: 1500, variant: "success" }
                        );
                        that.fetch_orders();
                    }
                    that.items_being_loaded = false;
                };

                let f = function(error) {
                    console.log(error);
                    that.$bvToast.toast(
                        "Error occurred in adding new container order. Please try again.",
                        { title: "Error", autoHideDelay: 1500, variant: "danger" }
                    );
                    that.items = that.items.filter(d => d.id !== item.id);
                    that.items_being_loaded = false;
                };

                this.items_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            validate(item) {
                if (item.data.status === 3 && Array.isArray(item.product_skus) && item.product_skus.length === 0) {
                    return [{ field: "status", message: "Cannot set status to SCHEDULED when there are 0 items in the container order." }];
                }

                if (!item.data.vendor_id) {
                    return [{ field: "vendor_id", message: "PLEASE INDICATE A VENDOR FOR THIS ORDER BEFORE SAVING." }];
                }
                if (item.data.status === 3 && !item.data.final_eta) {
                    return [{ field: "final_eta", message: "PLEASE ENTER A SCHEDULED ETA DATE BEFORE SETTING STATUS TO SCHEDULED." }];
                }
                if (item.data.status >= 2 && (!item.data.po_number || item.data.po_number.trim() === "")) {
                    return [{ field: "po_number", message: "ORDER NUMBER IS REQUIRED WHEN STATUS IS ORDERED OR BEYOND." }];
                }

                const duplicateError = this.validateUniqueNumbers(item);
                if (duplicateError) {
                    return [{ field: "po_number", message: duplicateError }];
                }

                if (!item.data.bill_to) {
                    return [{ field: "bill_to", message: "BILL TO LOCATION IS REQUIRED BEFORE SAVING." }];
                }

                if (!item.data.ship_to) {
                    return [{ field: "ship_to", message: "SHIP TO LOCATION IS REQUIRED BEFORE SAVING." }];
                }

                if (!item.data.receiving_location) {
                    return [{ field: "receiving_location", message: "RECEIVING LOCATION IS REQUIRED BEFORE SAVING." }];
                }

                return [];
            },
            update_container_order: function(item) {
                let data = item;
                let that = this;

                if (item.data.ordered_date_display) {
                    item.data.ordered_date = item.data.ordered_date_display;
                }

                if (item.data.schedule_date_display) {
                    item.data.schedule_date = item.data.schedule_date_display;
                }

                let errors = this.validate(item);
                if (errors.length > 0) {
                    let firstError = errors[0];

                    this.$vex.dialog.alert({
                        message: "• " + firstError.message,
                        unsafeHTML: true,
                        callback: () => {
                            this.$nextTick(() => {
                                let el;
                                if (firstError.field === "ship_to" || firstError.field === "bill_to" || firstError.field === "receiving_location") {
                                    el = document.querySelector(`select[name="${firstError.field}"]`);
                                } else {
                                    el = document.querySelector(`[name="${firstError.field}"]`);
                                }

                                if (el && typeof el.focus === "function") {
                                    el.focus();
                                }
                            });
                        }
                    });
                    return;
                }

                let path = "/api/vendor/update_container_order/"
                let s = function(response) {
                    if (response.data.error) {
                        that.$bvToast.toast(
                            response.data.error,
                            { title: "ERROR", autoHideDelay: 1500, variant: "danger" }
                        );
                    } else {
                        that.$bvToast.toast(
                            "SAVED",
                            { title: "SUCCESS", autoHideDelay: 1500, variant: "success" }
                        );
                    }
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred in saving. Please try again.",
                        { title: "Error", autoHideDelay: 1500, variant: "danger" }
                    );
                }
                Requestor.postSyncP(path, data, this, s, f);
            },
            fetch_orders: function() {
                let userLocationId = this.packet.userDetails ? this.packet.userDetails.properties.location_id : null;
                let userRole = this.packet.userDetails ? this.packet.userDetails.userrole : null;

                let data = {
                    status: this.status,
                    location_id: userLocationId,
                    userRole: userRole
                };

                let that = this;
                let path = "/api/vendor/get_container_orders/"
                let s = function(response) {
                    if (response.data.result) {
                        let normalizedItems = that.normalizeDates(response.data.result);
                        that.items = normalizedItems;
                        that.initializeCounters();
                    } else {
                        that.$bvToast.toast(
                            response.data.error || "No orders found",
                            { title: "Error", autoHideDelay: 1500, variant: "warning" }
                        );
                    }
                    that.items_being_loaded = false
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred. Please try again.",
                        { title: "Error", autoHideDelay: 1500, variant: "danger" }
                    );
                    that.items_being_loaded = false
                }
                this.items_being_loaded = true;
                Requestor.getAsyncP(path, data, this, s, f);
            },
            view_item: function(item) {
                this.container_order_id = item.id;
                this.container_order_vendor_id = item.data.vendor_id;
                this.$bvModal.show("modal-co-items");
            },
            close_co_items: function() {
                this.$bvModal.hide("modal-co-items");
                this.fetch_orders()
            },
            sort_by: function(key) {
                if (this.sort_asc) {
                    this.items = Requestor.sort(this.items, key)
                } else {
                    this.items = Requestor.sort_reverse(this.items, key)
                }
                this.sort_asc = !this.sort_asc;
            }
        },
        watch: {
            items: {
                handler: function(newItems) {
                    newItems.forEach(item => {
                        if (item.data) {
                            const dmrgCharges = parseFloat(item.data.dmrg_charges) || 0;
                            const handlingCharges = parseFloat(item.data.tariff_handling_charges) || 0;
                            const detentionCharges = parseFloat(item.data.tariff_detention_charges) || 0;
                            const totalFines = dmrgCharges + handlingCharges + detentionCharges;
                            
                            if (totalFines > 0) {
                                this.$set(item.data, 'total_fines', totalFines);
                            }
                            
                            const brokerFees = parseFloat(item.data.tariff_broker_fees) || 0;
                            const isfFilling = parseFloat(item.data.isf_flling) || 0;
                            const otherCost = totalFines + brokerFees + isfFilling;
                            this.$set(item.data, 'other_cost', otherCost);
                        }
                        
                        this.calculateLandedPrice(item);
                        this.autoSetOrderedStatus(item);
                    });
                },
                deep: true
            }
        },
        created: function() {
            this.packet = JSON.parse(localStorage.packet || '{}');
            if (this.packet.vendors) {
                this.packet.vendors.splice(0, 0, { value: null, text: "ALL" });
            }
            this.packet.userDetails = JSON.parse(localStorage.userDetails || '{}');
            this.setupLocations();
            this.categoryOptions = [
                { value: null, text: "ALL" },
                ...(this.packet.categories || []).map(cat => ({
                    value: cat.value,
                    text: this.packet.categoriesdict ? this.packet.categoriesdict[cat.value] || cat.text : cat.text
                }))
            ];
            this.fetch_orders();
        }
    }
</script>

<style scoped>
.btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.ordered-date-cell {
    font-weight: bold;
    color: #2e7d32;
    background-color: #e8f5e9;
}

.schedule-date-cell {
    font-weight: bold;
    color: #0d47a1;
    background-color: #e3f2fd;
}

.custom-time-input::-webkit-calendar-picker-indicator {
    filter: invert(0.5);
    cursor: pointer;
    padding: 2px;
}

.custom-time-input::-webkit-calendar-picker-indicator:hover {
    filter: invert(0.3);
}

.custom-time-input::-moz-calendar-picker-indicator {
    filter: invert(0.5);
    cursor: pointer;
}

.custom-time-input {
    color: #666 !important;
    background-color: #ffffff !important;
    border-radius: 4px;
    padding: 20px 14px;
}

.custom-time-input:focus {
    border-color: #888;
    box-shadow: 0 0 0 0.2rem rgba(136, 136, 136, 0.25);
    padding: 20px 14px;
}

.diver {
    overflow: auto;
    width: 100%;
    height: 600px;
    position: relative; 
}

td, th {
    border: 1px solid;
    width: 300px;
}

th {
    background-color: white;
}

table {
    table-layout: fixed;
    width: 100%;
    border-collapse: separate; 
    border-spacing: 0;
}

td:nth-child(-n+4), 
th:nth-child(-n+4) {
    position: sticky;
    left: 0;
    z-index: 1;
    background-color: white;
}
td:nth-child(1), th:nth-child(1) {
    left: 0;
}

td:nth-child(2), th:nth-child(2) {
    left: 150px;
}

td:nth-child(3), th:nth-child(3) {
    left: 300px;
}

td:nth-child(4), th:nth-child(4) {
    left: 450px;
}

td:last-child, th:last-child {
    position: sticky;
    right: 0;
    z-index: 1;
    background-color: white;
    width: 300px;
}

thead tr th {
    position: sticky;
    top: 0;
    z-index: 5;
    background-color: white;
}

th:nth-child(-n+4), th:last-child {
    z-index: 2;
    background-color: white;
}

thead tr th:nth-child(-n+4) {
    z-index: 7;
}

tbody tr td:nth-child(-n+4) {
    z-index: 2;
    background-color: white;
}

tbody tr td:last-child {
    z-index: 2;
    background-color: white;
}

tbody tr td:nth-child(-n+4):hover,
tbody tr td:last-child:hover {
    background-color: white;
}

.diver table {
    border-collapse: separate;
    border-spacing: 0;
}

thead tr th:last-child {
    z-index: 7;
}

.srr {
    font-size: 11px;
    text-align: center;
    background: #efefef;
    border: 1px solid #010101;
}

.srrv {
    font-size: 13px;
    text-align: center;
    background: white;
    border: 1px solid #010101;
    padding: 5px;
}

.modal-xl {
    min-width: 1000px !important;
}

.box {
    padding: 3px;
    text-align: center;
    margin: 5px;
    background: #ffc107;
    color: black;
    border: 1px solid black;
}

@media (max-width: 768px) {
    td:nth-child(-n+4),
    th:nth-child(-n+4),
    td:last-child,
    th:last-child,
    thead tr th {
        position: static !important;
        left: auto !important;
        right: auto !important;
        top: auto !important;
        z-index: auto !important;
    }

    .diver {
        height: auto;
        overflow-x: auto;
        overflow-y: auto;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/VendorOrders/ListContainerOrders.vue